// menuItems.js
import React from "react";

// Fungsi untuk membuat menu items dinamis
export const createMenuItems = (
  userRole,
  openDms,
  openLocation,
  openLabita,
  openPengamatan,
  openPpic,
  openPlantation,
  openBoomspray,
  openHarvesting,
  openProduction,
  openInventoryMasterData,
  handleToggleDrawerMenu
) => {
  const baseMenuItems = [
    {
      text: "Dashboard",
      icon: "Home",
      path: "/dashboard",
    },
    {
      text: "Peta Estate 4",
      icon: "MapOutlined",
      path: "/peta-estate4",
    },
    {
      text: "Location",
      icon: "PushPin",
      isCollapsible: true,
      openState: openLocation,
      toggleHandler: handleToggleDrawerMenu("location"),
      subItems: [
        {
          text: "Location Status",
          icon: "LegendToggleOutlined",
          path: "/lokasi/active-plantation",
        },
        //{
        //  text: "Histori",
        //  icon: "HistoryOutlined",
        //  path: "/lokasi/closing-plantation",
        //},
      ],
    },
    {
      text: "Activity",
      isLabel: true,
    },
    {
      text: "Labita",
      icon: "Agriculture",
      isCollapsible: true,
      openState: openLabita,
      toggleHandler: handleToggleDrawerMenu("labita"),
      subItems: [
        {
          text: "Stok Lahan",
          icon: "Labels",
          path: "/labita/stok-lahan",
        },
        {
          text: "YTD",
          icon: "Labels",
          path: "/labita/ytd",
        },
        {
          text: "Master Budget Tanam",
          icon: "Labels",
          path: "/labita/master-budget-tanam",
        },
      ],
    },
    {
      text: "Plantation",
      icon: "Grass",
      isCollapsible: true,
      openState: openPlantation,
      toggleHandler: handleToggleDrawerMenu("plantation"),
      subItems: [
        {
          text: "Setara Urea Per Umur",
          icon: "Labels",
          path: "/plantation/monitor-setara-urea-per-umur",
        },
        {
          text: "Standar Per Umur",
          icon: "Labels",
          path: "/plantation/standar-per-umur",
        },
      ],
    },
    {
      text: "Boom Spray",
      icon: "Shower",
      isCollapsible: true,
      openState: openBoomspray,
      toggleHandler: handleToggleDrawerMenu("boomspray"),
      subItems: [
        {
          text: "Rencana Boom Spraying",
          icon: "Labels",
          path: "/boom-sprayer/monitor-recana-boom",
        },
        {
          text: "PJ Wilayah",
          icon: "Labels",
          path: "/boom-sprayer/master-data",
        },
      ],
    },
    {
      text: "Observation",
      icon: "YardOutlined",
      isCollapsible: true,
      openState: openPengamatan,
      toggleHandler: handleToggleDrawerMenu("pengamatan"),
      subItems: [
        {
          text: "Distribusi Size & Kematangan",
          icon: "PieChartOutlineOutlined",
          path: "/",
        },
        {
          text: "Berat Tanaman",
          icon: "ScaleOutlined",
          path: "/pengamatan/berat-tanaman",
        },
        {
          text: "Persen Bunga",
          icon: "LocalFloristOutlined",
          path: "/pengamatan/persen-bunga",
        },
        {
          text: "Buah Alami",
          icon: "SpaOutlined",
          path: "/pengamatan/buah-alami",
        },
        {
          text: "Destrak",
          icon: "BugReportOutlined",
          path: "/pengamatan/destrak-v1",
        },
        {
          text: "Sensus Populasi Anakan Pisang",
          icon: "ScatterPlotOutlined",
          path: "/pengamatan/sensus-populasi-anakan-pisang",
        },
      ],
    },
    {
      text: "Harvesting",
      icon: "LocalShipping",
      isCollapsible: true,
      openState: openHarvesting,
      toggleHandler: handleToggleDrawerMenu("harvesting"),
      subItems: [
        {
          text: "Monitor Hasil Panen",
          icon: "Labels",
          path: "/harvesting/monitor-hasil-panen",
        },
      ],
    },
    {
      text: "Productions",
      icon: "FactoryOutlined",
      isCollapsible: true,
      openState: openProduction,
      toggleHandler: handleToggleDrawerMenu("production"),
      subItems: [
        {
          text: "PH 01 Daily Production",
          icon: "Labels",
          path: "/prodactions/ph01",
        },
        {
          text: "PH 02 Daily Production",
          icon: "Labels",
          path: "/prodactions/ph02",
        },
        {
          text: "Master Data",
          icon: "Labels",
          path: "/prodactions/master-data",
        },
        {
          text: "Distribution Mapping",
          icon: "Labels",
          path: "/prodactions/master-data/distribution-mapping",
        },
        {
          text: "Trade Sectors",
          icon: "Labels",
          path: "/prodactions/master-data/trade-sectors",
        },
        {
          text: "Classification Categories",
          icon: "Labels",
          path: "/prodactions/master-data/classification-categories",
        },
        {
          text: "Product Specifications",
          icon: "Labels",
          path: "/prodactions/master-data/product-specifications",
        },
        {
          text: "Production Plan",
          icon: "Labels",
          path: "/prodactions/master-data/production-plan",
        },
      ],
    },
    {
      text: "Inventory",
      isLabel: true,
    },
    {
      text: "Realisasi & Stok",
      icon: "FactCheckOutlined",
      path: "/inventory/realisasi",
    },
    {
      text: "Forecast Bahan",
      icon: "BatchPredictionOutlined",
      path: "/inventory/forecast",
    },
    {
      text: "Master Data",
      icon: "StoreOutlined",
      isCollapsible: true,
      openState: openInventoryMasterData,
      toggleHandler: handleToggleDrawerMenu("masterdata"),
      subItems: [
        {
          text: "Material Category",
          icon: "Category",
          path: "/inventory/material-category",
        },
        {
          text: "Unit of Measurement",
          icon: "Straighten",
          path: "/inventory/uom",
        },
        {
          text: "Material Master",
          icon: "Inventory2Outlined",
          path: "/inventory/material-master",
        },
      ],
    },
    {
      text: "Drone",
      isLabel: true,
    },
    {
      text: "Flight Plan",
      icon: "ScienceOutlined",
      path: "/",
    },
    {
      text: "Buah Alami",
      icon: "SpaOutlined",
      path: "/drone/buah-alami",
    },
    {
      text: "Banana",
      isLabel: true,
    },
    {
      text: "Banana",
      icon: "ScienceOutlined",
      path: "/banana",
    },
    {
      text: "Purchase Requisition",
      isLabel: true,
    },
    {
      text: "Outstanding Pengajuan",
      icon: "PlaylistAddCheckCircleOutlined",
      path: "/purchase-requisition/pengajuan-barang-expand"
    },
    {
      text: "History Pengajuan",
      icon: "InventoryOutlined",
      path: "/purchase-requisition/history-pengajuan/history-pengajuan-barang-expand"
    },
    
  ];

  const newMenuItems = [...baseMenuItems];
  
  const allowedRolesForMaterialExpand = [
    "developer",
    "inv management freshpine & other",
    "prcn. & inv. material pack ph"
  ];

  const canAccessMaterialExpand = userRole && allowedRolesForMaterialExpand.includes(userRole);

  const allowedRolesForSummaryPR = [
    "developer",
    "inv management freshpine & other",
    "prcn. & inv. material pack ph"
  ];

  const canAccessSummaryPR = userRole && allowedRolesForSummaryPR.includes(userRole);
  //const canAccessSummaryPR = userRole && allowedRolesForSummaryPR.some(
  //  role => role.toLowerCase() === userRole.toLowerCase()
  //);

  if (canAccessSummaryPR) {
    newMenuItems.push({
      text: "Summary PR",
      icon: "AnalyticsOutlined",
      path: "/purchase-requisition/summary-pr"
    });
  }

  if (canAccessMaterialExpand) {
    const materialExpandMenuItem = {
      text: "Material Expand",
      icon: "LocalShippingOutlined",
      isCollapsible: true,
      openState: openPpic,
      toggleHandler: handleToggleDrawerMenu("ppic"),
      subItems: [
        {
          text: "Dashboard",
          icon: "DashboardOutlined",
          path: "/ppic/dashboard",
        },
        {
          text: "Order",
          icon: "ReceiptOutlined",
          path: "/ppic/order",
        },
        {
          text: "Katalog",
          icon: "CategoryOutlined",
          path: "/ppic/katalog",
        },
        {
          text: "Transaksi",
          icon: "AttachMoneyOutlined",
          path: "/ppic/transaksi",
        },
        {
          text: "Cost Center",
          icon: "PieChartOutlineOutlined",
          path: "/ppic/cost-center",
        },
        {
          text: "UoM",
          icon: "StraightenOutlined",
          path: "/ppic/uom",
        },
        {
          text: "Kategori",
          icon: "CategoryOutlined",
          path: "/ppic/kategori",
        },
        {
          text: "Berita Acara",
          icon: "DescriptionOutlined",
          path: "/ppic/berita-acara",
        },
      ],
    };
    newMenuItems.push(materialExpandMenuItem);
  }

  if (userRole === "developer") {
    const dmsMenuItem = {
      text: "DMS",
      icon: "Code",
      isCollapsible: true,
      openState: openDms,
      toggleHandler: handleToggleDrawerMenu("dms"),
      subItems: [
        {
          text: "WFMS",
          icon: "People",
          path: "/dms/workforce-management",
        },
        {
          text: "FPMS",
          icon: "LocalShippingOutlined",
          path: "/dms/fresh-pineapple-management-system",
        },
        {
          text: "DBMS",
          icon: "AccountTreeOutlined",
          path: "/dms/database-management-system",
        },
        {
          text: "Helper",
          icon: "HelpOutline",
          path: "/dms/helper",
        },
        {
          text: "GJMS",
          icon: "MapOutlined",
          path: "/dms/geojson-management-system",
        },
        { text: "SCM", icon: "AssignmentTurnedInOutlined", path: "/dms/supply-chain-management" },
        { text: "OMS", icon: "AssignmentTurnedInOutlined", path: "/dms/observation-management-system" },
      ],
    };
    newMenuItems.splice(24, 0, dmsMenuItem);
  }

  newMenuItems.push({
    text: "About",
    isLabel: true,
  });

  newMenuItems.push({
    text: "Changelog",
    icon: "History",
    path: "/about/changelog",
  });

  return newMenuItems;
};